import React, { useCallback } from "react";
import iconConoceMas from "../../../assets/icons/ic-conoce-mas.svg";
import { useWindowResize } from "../../../hooks/use-windows-resize";
import { scrollToElementByQuery } from "../../../libs/utils/dom";

export const LandingKnowMoreArrow = () => {
    const { width, isMobile } = useWindowResize();
    const handleClick = useCallback(() => {
        scrollToElementByQuery("#quote-button", 20);
    }, []);
    if (isMobile) {
        return (
            <div className="landing-intro__know-more" onClick={handleClick}>
                <img src={iconConoceMas} alt="conoce mas" />
            </div>
        );
    }
    return (
        <div
            data-testid="LandingKnowMoreArrow"
            className="landing-intro__know-more"
            style={{ bottom: width > 1650 ? "25%" : "22%" }}
            onClick={handleClick}
        >
            <img src={iconConoceMas} alt="conoce mas" />
        </div>
    );
};
